import React from "react";
import { NewsHeading } from "./news-heading";
import PropTypes from "prop-types";
import get from "lodash/get";
import "./breaking-news.module.css";
import Marquee from "../marquee/src/index";
import { isEmpty } from "../../utils";

class BreakingNewsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentNewsId: 0
    };
  }

  getBreakingNewsTitle() {
    const breakingNewsTitle = get(this.props, ["config", "theme-attributes", "breaking-news-config", "title"]);
    return breakingNewsTitle || "Breaking News";
  }

  getBreakingNewsTemplateStyle() {
    const breakingNewsTemplate = get(
      this.props,
      ["config", "theme-attributes", "breaking-news-config", "template"],
      "template1"
    );
    return breakingNewsTemplate === "template1" ? "container" : "full-width-container";
  }
  render() {
    if (isEmpty(this.props.breakingNews)) {
      return <span />;
    }

    const newsArray = this.props.breakingNews.map((breakingNews, index) => (
      <NewsHeading story={breakingNews} key={breakingNews.id} index={index} />
    ));
    const scrollSpeed = parseInt(
      get(this.props, ["config", "theme-attributes", "breaking-news-config", "scrollSpeed"], 1)
    );
    const delimiter = get(this.props, ["config", "theme-attributes", "breaking-news-config", "delimiter"], "dot");
    const bgColor = get(this.props, ["config", "pagebuilder-config", "home", "homepageSetting", "bgColor"], "");
    return (
      <div styleName="bg-wrapper" style={{ backgroundColor: bgColor }}>
        <div
          styleName={`breaking-news-collection-wrapper ${this.getBreakingNewsTemplateStyle()}`}
          data-breaking-news="true"
        >
          <h2 styleName="title">
            <bdi>{this.getBreakingNewsTitle()}</bdi>
          </h2>
          <div styleName=" content breaking-news-wrapper">
            <Marquee
              direction={"landscape"}
              loop={true}
              scrollSpeed={scrollSpeed}
              loopData={newsArray}
              delimiter={delimiter}
            />
          </div>
        </div>
      </div>
    );
  }
}
BreakingNewsView.propTypes = {
  breakingNews: PropTypes.array
};

export { BreakingNewsView };
